import { render, staticRenderFns } from "./PerfilDeAcesso.vue?vue&type=template&id=2bb1c0ea&scoped=true"
import script from "./PerfilDeAcesso.vue?vue&type=script&lang=js"
export * from "./PerfilDeAcesso.vue?vue&type=script&lang=js"
import style0 from "../../../css/crud.css?vue&type=style&index=0&id=2bb1c0ea&prod&scoped=true&lang=css&external"
import style1 from "./PerfilDeAcesso.vue?vue&type=style&index=1&id=2bb1c0ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb1c0ea",
  null
  
)

export default component.exports